import type { ReactNode } from 'react'

export function Root({
  children,
  folded = false,
}: {
  children: ReactNode
  folded?: boolean
}) {
  return (
    <div
      className='grid-areas-layout grid grid-cols-layout grid-rows-layout gap-x-4 gap-y-3 pr-4 data-[folded=true]:grid-cols-layout-folded'
      data-folded={folded}
    >
      {children}
    </div>
  )
}
